<div class="container">
  <div class="top-buttons">
    <div class="button">customer</div>
    <div class="button">device</div>
    <div class="button">tag</div>
  </div>
</div>
